import DefaultLayout from '../../components/layouts/default-layout/DefaultLayout';
import { Route, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ExamArea from '../../components/exams/exam-area/ExamArea';
import RequestNewExam from '../../components/exams/request-new-exam/RequestNewExam';
import StudentExam from '../../routes/student-exam/StudentExam';
import ExamCalculator from '../../components/exams/exam-calculator/ExamCalculator';
import EmptyLayout from '../../components/layouts/empty-layout/EmptyLayout';
import { DefaultLayoutHeaderType } from '../../components/layouts/default-layout/DefaultLayout.models';
import TakeExam from '../../components/exams/take-exam/TakeExam';
import StudentExamSummary from '../../components/exams/student-exam-summary/StudentExamSummary';
import ViewExamResults from '../../components/exams/view-exam-results/ViewExamResults';
import ExamAnswerSheet from '../../components/exams/exam-answeer-sheet/ExamAnswerSheet';
import StartExamRoute from '../start-exam-route/StartExamRoute';
import WorkBookRoute from '../work-book-route/WorkBookRoute';
import ExamIntroduction from '../../components/exams/exam-introduction/ExamIntroduction';
import { useEffect, useState } from 'react';
import ExamReportRoute from '../exam-report/ExamReportRoute';

export default function ExamRoute() {
    const [searchParams] = useSearchParams();
    const location = useLocation()
    const [route, setRoute] = useState({
        to: location.pathname,
        from: location.pathname
    });
    useEffect(() => {
        setRoute((prev) => ({ to: location.pathname, from: prev.to }))
    }, [location]);

    return <>
        {examsRoute()}
        {ratingEstimateRoute()}

        <Route element={<DefaultLayout backUri={"/StartExam"} title={"آزمون های جاری"} />}>
            <Route path="/CurrentExam" element={<ExamArea statusPage={'0'} />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/StartExam"} title={"آزمون های جامع"} />}>
            <Route path="/FutureExam" element={<ExamArea statusPage={'1'} />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/StartExam"} title={"آزمون های تعیین سطح"} />}>
            <Route path="/ComprehensiveExam" element={<ExamArea statusPage={'3'} />} />
        </Route>

        <Route element={<DefaultLayout backUri={(route.from && !route.from.includes('ExamIntroduction')) ? route.from : "/StartExam"} title={"معرفی آزمون"} />}>
            <Route path="/ExamIntroduction" element={<ExamIntroduction examId={Number(searchParams.get('examId'))} />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/StartExam"} title={"درخواست آزمون"} />}>
            <Route path="/RequestExamList" element={<ExamArea statusPage={'2'} />} />
        </Route>

        <Route element={<DefaultLayout showContactUs={false} showDefaultHeader={DefaultLayoutHeaderType.none} backUri={"/Exams"} title={"آزمون"} />}>
            <Route path="/Exam" element={<TakeExam examId={searchParams.get('examId')} examResultId={searchParams.get('examResultId')} />} />
        </Route>

        <Route element={<DefaultLayout showDefaultHeader={DefaultLayoutHeaderType.none} backUri={"/Exams"} title={"آزمون"} />}>
            <Route path="/StudentExamSummary" element={<StudentExamSummary examResultId={searchParams.get('examResultId')} />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/RequestExamList"} title={"درخواست آزمون جدید"} />}>
            <Route path="/RequestExam" element={<RequestNewExam />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/ViewExamResults"} title={"نتیجه آزمون"} />}>
            <Route path="/AnswerSheet" element={<ExamAnswerSheet examResultId={searchParams.get('examResultId')} />} />
        </Route>

        
        <Route element={<DefaultLayout backUri={"/ViewExamResults"} title={"کارنامه ی آزمون جامع"} />}>
            <Route path="/ExamReport" element={<ExamReportRoute statusPage={searchParams.get('statusPage')} examId={searchParams.get('examId')} examResultId={searchParams.get('examResultId')} />} />
        </Route>
    </>
}

export function examsRoute() {
    return <>
        <Route element={<DefaultLayout showFooter={true} showDefaultHeader={DefaultLayoutHeaderType.showDefaultHeader} />}>
            <Route path="/Exams" element={<StudentExam />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/Exams"} title={"ماشین حساب آزمون"} />}>
            <Route path="/ExamCalculator" element={<ExamCalculator />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/Exams"} title={"شرکت در آزمون"} />}>
            <Route path="/StartExam" element={<StartExamRoute />} />
        </Route>

        <Route element={<DefaultLayout showDefaultHeader={DefaultLayoutHeaderType.none} backUri={"/Exams"} title={"تخمین رتبه"} />}>
            <Route path="/RatingEstimate" element={<WorkBookRoute />} />
        </Route>


        <Route element={<EmptyLayout />}>
            <Route path="/ViewExamResults" element={<ViewExamResults />} />
        </Route>
    </>;
}

export function ratingEstimateRoute() {
    return <>

        {/* <Route element={<DefaultLayout backUri={"/RatingEstimate"} title={"تخمین رتبه"} />}>
            <Route path="/RatingEstimate/PercentageCourses" element={<RatingEstimatesPercentageCourses />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/RatingEstimate/PercentageCourses"} title={"تخمین رتبه"} />}>
            <Route path="/RatingEstimateList" element={<RatingEstimatesList />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/RatingEstimateList"} title={"تخمین رتبه"} />}>
            <Route path="/RatingEstimate/RealResults" element={<RatingEstimatesRealResultsList />} />
        </Route> */}


    </>;
}
